import React from "react";
import Lock from "../assets/sloth/hex.png";

import Team1 from "../assets/team-cards/alej.png"
import Team2 from "../assets/team-cards/elpi.png"
import Team3 from "../assets/team-cards/civi.png"
import Team4 from "../assets/team-cards/kiory.png"
import {Fade, Flip} from 'react-awesome-reveal';
const TeamCard = (props) => {
    return(
        <div className="grid lg:grid-cols-6 text-left gap-x-[50px]">
            <div className="lg:col-span-3">
                <Flip>
                <img src={props.image} className='w-[45%] mx-auto lg:w-full'/>
                </Flip>
            </div>
            <div className="space-y-[8px] lg:col-span-3 h-full flex items-center lg:items-start justify-center flex-col pt-[5px] lg:pt-0">
                <h3 className="subtitle-name">
                    {props.name}
                </h3>
                <p className="subtitle text-[#68DDB0]">
                    {props.title}
                </p>
            </div>
        </div>
    )
}

const OurTeam = () => {
    return(
        <section className="container-theme text-[#0D3727] text-center" id="team">
              <Fade cascade duration={300}>

            <h2 className="h2 uppercase">
            Our Team
            </h2>
            <p className="body-1 pt-[30px] lg:pt-[60px] max-w-[874px] mx-auto">
            The Slow Mo team has extensive and diverse experience ranging from feature film and games to online marketplaces and web3 experiences.        </p>
            <div className="pt-[45px] lg:pt-[85px] grid lg:grid-cols-2 gap-y-[40px] lg:gap-y-[60px] gap-x-[100px]">
              <Fade cascade duration={300}>
                
                <TeamCard image={Team1} name={`ALEJOMEVEZ`} title={`LEAD UX DESIGNER`}/>

                <TeamCard image={Team2} name={`EL PAPI`} title={`LEAD UI DESIGNER`}/>
                <TeamCard image={Team3} name={`CivilMuffin`} title={`artist`}/>
                <TeamCard image={Team4} name={`Kiory`} title={`artist`}/>
                </Fade>

            </div>
            </Fade>
        </section>
    )
}

export default OurTeam